import React from 'react';
import { connect } from 'react-redux';
import { RawFileBrowser } from 'react-keyed-file-browser';
import moment from 'moment';
import Dropzone from 'react-dropzone';

import assetSource from '../sources/assets';
import { addNotification } from '../actions/reduxActions/notification';
import { notificationTypes } from '../constants';

import '../../css/assets.less';
import 'react-keyed-file-browser/dist/react-keyed-file-browser.css';

export class Assets extends React.Component {

    constructor(props) {
        super(props);

        this.notificationStrings = {
            POST: {
                success: ' has been successfully uploaded.',
                error: 'There was an error uploading ',
            },
            PUT: {
                success: ' has been successfully modified.',
                error: 'There was an error modifying ',
            },
            DELETE: {
                success: ' has been successfully deleted.',
                error: 'There was an error deleting ',
            },
        };

        this.state = {
            files: [],
            isLoading: true,
        };
    }

    componentDidMount() {
        this.fetchAssets();
    }

    onDeleteFile = (fileName) => {
        this.setState({
            isLoading: true,
        });
        const payload = JSON.stringify({
            key: fileName,
        });
        return assetSource.deleteAsset(this.props.tenantId, this.props.authenticationToken, payload)
            .then(() => {
                this.fetchAssets();
                this.forceUpdate();
                if (this.closePreview) this.closePreview();
                this.setState({ isLoading: false });
                this.props.addNotification({
                    type: notificationTypes.SUCCESS,
                    message: fileName + this.notificationStrings.DELETE.success,
                });

                if (this.props.onAssetDelete) this.props.onAssetDelete();
            })
            .catch(() => {
                this.setState({ isLoading: false });
                this.props.addNotification({
                    type: notificationTypes.ERROR,
                    message: this.notificationStrings.DELETE.error + fileName, 
                });
            });
    }

    onMoveItem = (oldKey, newKey) => {
        this.setState({
            isLoading: true,
        });

        const payload = JSON.stringify({
            oldKey,
            newKey,
        });

        if (oldKey !== newKey) {
            return assetSource.moveAsset(this.props.tenantId, this.props.authenticationToken, payload)
                .then(() => { 
                    this.fetchAssets();
                    this.setState({ isLoading: false });
                    this.props.addNotification({
                        type: notificationTypes.SUCCESS,
                        message: oldKey + this.notificationStrings.PUT.success,
                    });
                    if (this.closePreview) this.closePreview();

                    if (this.props.onAssetUpdate) this.props.onAssetUpdate(oldKey, newKey);

                })
                .catch(() => {
                    this.setState({ isLoading: false });
                    this.props.addNotification({
                        type: notificationTypes.ERROR,
                        message: this.notificationStrings.PUT.error + oldKey, 
                    });
                });
        }

        return null;
    }

    onMoveFolder = () => false
    

    onRenderDetail = (props) => {
        this.closePreview = props.close;
        if (this.props.onAssetSelect) this.props.onAssetSelect(props.file.url);

        return (
            <div className="iframeWrapper visible-md visible-lg">
                <iframe sandbox="" src={props.file.url} title="asset-preview" />
            </div>
        );
    }

    onDrop = (files) => {
        if (files.length > 0) {
            this.setState({
                isLoading: true,
            });

            const uploads = [];

            files.forEach((file) => {
                if (file.name.length > 0) {

                    const payload = JSON.stringify({
                        contentType: file.type,
                        key: file.name,
                    });

                    const upload = assetSource.createAsset(this.props.tenantId, this.props.authenticationToken, payload)
                        .then((response) => {
                            assetSource.uploadAsset(response, this.props.tenantId, this.props.authenticationToken, file)
                                .then(() => {
                                    this.fetchAssets();
                                    this.setState({ isLoading: false });
                                    this.props.addNotification({
                                        type: notificationTypes.SUCCESS,
                                        message: file.name + this.notificationStrings.POST.success,
                                    });
                                })
                                .catch(() => {
                                    this.setState({ isLoading: false });
                                    this.props.addNotification({
                                        type: notificationTypes.ERROR,
                                        message: this.notificationStrings.POST.error + file.name, 
                                    });
                                });  
                        })
                        .catch(() => {
                            this.setState({ isLoading: false });
                            this.props.addNotification({
                                type: notificationTypes.ERROR,
                                message: this.notificationStrings.POST.error + file.name, 
                            });
                        });

                    uploads.push(upload);

                }

            });

            /**
             * An array of upload requests are returned.
             * This is so that when testing this function we can
             * test that every promise in the loop resolves.
             */
            return uploads;

        } 

        this.setState({ isLoading: false });
        this.props.addNotification({
            type: notificationTypes.ERROR,
            message: 'Error! File not uploaded.', 
        });

        return null;
    }

    fetchAssets() {
        this.setState({
            isLoading: true,
        });
        assetSource.getAssets(this.props.tenantId, this.props.authenticationToken)
            .then((response) => {
                const resp = response.map((file) => {
                    const currentDate = moment();
                    const diff = currentDate.diff(moment(file.modifiedAt));
                    return {
                        key: file.key.slice(37),
                        modified: currentDate.subtract(diff),
                        size: file.size,
                        url: file.publicUrl,
                    };
                });

                this.setState({
                    files: resp,
                    isLoading: false,
                });
            });
    }

    render() {
        const Wait = manywho.component.getByName('wait');

        return (
            <div className="assets">
                <Dropzone className="dropzone" onDrop={this.onDrop}>
                    <div>Drop files here, or click to select files</div>
                </Dropzone>

                <RawFileBrowser
                    files={this.state.files}
                    onDeleteFile={this.onDeleteFile}
                    onRenameFile={this.onMoveItem}
                    detailRenderer={this.onRenderDetail}
                    onRenameFolder={this.onMoveFolder}
                />
                <Wait isVisible={this.state.isLoading} />
            </div>
        );

    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
    { addNotification },
)(Assets);
